import React, { useRef, useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import stores from 'cd-eft/models/Stores';
import { DeleteElement } from 'cd-eft/components/Design/common/DeleteElement/DeleteElement';
import { SurveySummaryVM, getSurveys } from './SurveySummaryVM';
import { Popup } from 'cd-eft/components/common/Popup';
import { mdiExitToApp } from '@mdi/js';
import './SurveySummary.scss';
import { Table } from 'reactstrap';
import { ActionsMenu } from 'cd-eft/components/Design/common/ActionsMenu';
import { DEMSurfaceSummaryTable } from '../DEMSurfaceSummaryTable';

const AppStore = stores.AppStore;
const setStore = stores.AppStore.surveyEngineeringStore;
const designStore = stores.AppStore.designStore;

const SurveySummaryComponent = (props) => {
  const vm = useRef(new SurveySummaryVM(props)).current;

  useEffect(() => {
    if (designStore.currentSurface.surfaceDefId) {
      getSurveys();
    }
  }, [designStore.currentSurface.surfaceDefId]);

  return (
    <div className="set-data-grid-container">
      <div className="surface-name">

        {/* <Surface type Selection (Survey vs. DEM Surface) /> */}
        <div className="form-row-fixed-height">
          <div className="usa-radio">
            <input
              className="usa-radio__input usa-radio__input--tile"
              id="survey-select"
              data-testid="survey-select"
              type="radio"
              name="survey-select"
              value="survey"
              disabled={setStore.savedDEM}
              checked={setStore.in_designTypeSelection != 'demSurface'}
              onChange={() => {
                setStore.in_designTypeSelection = 'survey';
              }}
            />
            <label className="usa-radio__label radio-custom-button" htmlFor="survey-select">
              Survey
            </label>
          </div>

          {AppStore.userProfileStore.applicationFlags.enabledemfordesign && <div className="usa-radio">
            <input
              className="usa-radio__input usa-radio__input--tile"
              id="dem-select"
              data-testid="dem-select"
              type="radio"
              name="dem-select"
              value="demSurface"
              disabled={setStore.savedSurvey}
              checked={setStore.in_designTypeSelection == 'demSurface'}
              onChange={() => {
                setStore.in_designTypeSelection = 'demSurface';
              }}
            />
            <label className="usa-radio__label radio-custom-button" htmlFor="dem-select">
              DEM Surface
            </label>
          </div>}
        </div>

        <div className="form-row-fixed-height">
          <label className="usa-label label-with-fixed-width" htmlFor="surface-name">
            Surface Name:
          </label>
          <input
            className="form-control-plaintext px-2"
            id="surface-name"
            name="surface-name"
            type="text"
            value={designStore.currentSurface.surfaceDefTitle}
            readOnly
          />
        </div>
      </div>

      {/* Survey table and its related buttons will be displayed only if user selects the survey radio button/> */}
      <div className="set-table-container width-auto" hidden={setStore.in_designTypeSelection == 'demSurface'}>
        <Table className="set-table">
          <thead>
            <tr>
              <th className="narrow-td">Select</th>
              <th>Name</th>
              <th>Type</th>
              <th>#Points</th>
              <th>Date</th>
              <th className="narrow-td">Actions</th>
            </tr>
          </thead>
          <tbody>
            {setStore.surveySummaryTable.map((item: any, i) => {
              return (
                <tr key={'key' + i}>
                  <td className="text-center">
                    <input
                      id={'select' + i}
                      data-testid={'select' + i}
                      name="select"
                      type="checkbox"
                      checked={setStore.selectedSurveysInfo.includes(item.surveyId)}
                      value={i}
                      onChange={vm.handleCheckboxChange}
                    />
                  </td>
                  <td>
                    <label htmlFor={'select' + i} className="text-normal m-0 link">
                      {item.surveyName}
                    </label>
                  </td>
                  <td>{vm.surveyTypeName[item.surveyType]}</td>
                  <td>{item.pointsCount}</td>
                  <td>{item.surveyDate}</td>
                  <td>
                    <ActionsMenu i={i} item={item} elementActions={vm.elementActions} />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>

        {!setStore.isLoading && !designStore.isLoading && setStore.surveySummaryTable.length === 0 && (
          <div className="h4 m-5 text-center">Add your first Survey</div>
        )}
      </div>

      <div className="form-row-fixed-height justify-content-between mt-4 mb-0" hidden={setStore.in_designTypeSelection == 'demSurface'}>
        <div>
          <button
            className="usa-button"
            id={`addSurvey`}
            data-testid={`addSurveyButton`}
            disabled={props.disableAdd || setStore.isStatePlane}
            onClick={vm.importSurveyHandler}
          >
            Add Survey
          </button>
        </div>

        <div className="display-flex align-items-center">
          <div>
            <button
              data-testid="refreshElements"
              className={`usa-button ${setStore.surveySummaryTable.length === 0 ? 'usa-button--disabled' : 'usa-button--outline'}`}
              onClick={vm.openEditAllSurvey}
            >
              Edit All Surveys
            </button>
            <button
              data-testid="refreshElements"
              className={`usa-button mr-0 ${setStore.surveySummaryTable.length === 0 ? 'usa-button--disabled' : 'usa-button--outline'}`}
              onClick={vm.onDisplayGroundPoints}
            >
              Display Survey
            </button>
          </div>
        </div>
      </div>


      {/* DEM surface table and its related buttons will be displayed only if user selects the DEM radio button/> */}
      {/* setStore.in_designTypeSelection: the global variable use to track the type of design project user is working with*/}
      <div hidden={setStore.in_designTypeSelection != 'demSurface'}>
        <DEMSurfaceSummaryTable designREF={props.designREF} />
      </div>


      {/* popups */}

      {vm.deleteSurveyWindowIsOpen && (
        <DeleteElement
          trigger={vm.deleteSurveyWindowIsOpen}
          setTrigger={vm.toggleDeleteSurvey}
          element="survey"
          name={vm.surveyToDelete.surveyName}
          action={vm.deleteSurvey}
        />
      )}

      {vm.warningDialogIsOpen && setStore.isImportingNewSurvey && (
        <Popup
          icon={mdiExitToApp}
          trigger={vm.warningDialogIsOpen}
          setTrigger={vm.toggleWarningDialog}
          title="You have unsaved changes"
          handleCancel={vm.warningDialogDiscardAction}
          cancelText="Discard"
          handleAction={vm.warningDialogReturnAction}
          actionText="Return to unsaved"
          handleOK={vm.warningDialogSaveAction}
          okText="Save"
        >
          {vm.surveyToEdit.surveyName ? (
            <p>
              Edit <span className="text-underline">{vm.surveyToEdit.surveyName}</span> survey will discard the{' '}
              <span className="text-underline">{setStore.currentSurvey.surveyName}</span> data.
            </p>
          ) : (
            <p>
              You have unsaved changes on survey{' '}
              <span className="text-underline">{setStore.currentSurvey.surveyName}</span>.
            </p>
          )}

          <p>Do you want to discard, return to editing or save changes?</p>
        </Popup>
      )}
    </div>
  );
};

export const SurveySummary = observer(SurveySummaryComponent);
